const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_APP_SETTING_TYPES':
      return {...state, ...action.settingTypes}
    default:
      return state;
  }
}
